module.exports = __webpack_public_path__ + "static/media/hashtag-nft-22.4bff5cd6.jpg";